/**
 * TopNavInsetProvider — publishes how much of the TOP safe area the global
 * mobile/tablet top bar has ALREADY paid for, so screens stop paying it twice.
 *
 * THE BUG THIS EXISTS TO KILL
 *
 * `MobileTopNav` is a flex SIBLING of the navigator inside `AppShell` (never
 * `position: absolute`), so a screen's top edge already starts below the bar —
 * exactly like the bottom tab bar works. `ScreenContainer` then added
 * `insets.top` a second time INSIDE the scene: a band of dead space under the
 * bar on every tab root, and the first row of content pushed down by the notch.
 *
 * WHY THE RESERVATION IS PUBLISHED, NOT MEASURED
 *
 * `(tabs)/_layout.tsx` knows synchronously whether the bar renders
 * (`shouldShowMobileTopNav(pathname)`), so it is the one that publishes it.
 * Measuring the bar's own layout would flash the wrong padding on the first
 * frame and on every route change.
 *
 * Absent provider ⇒ 0, deliberately: a screen outside the tab navigator owns
 * its own top edge, and if this provider ever failed to mount the app would
 * degrade to the old behaviour rather than tuck content under the bar.
 */
import React, { createContext, useContext } from 'react'

const TopNavInsetContext = createContext<number>(0)

interface TopNavInsetProviderProps {
  /** How much of `insets.top` the visible mobile top bar already spends. 0 when hidden. */
  reservation: number
  children: React.ReactNode
}

export function TopNavInsetProvider({ reservation, children }: TopNavInsetProviderProps) {
  return <TopNavInsetContext.Provider value={reservation}>{children}</TopNavInsetContext.Provider>
}

/** Top safe area the mobile top bar already occupies above the current screen. */
export function useTopNavInset(): number {
  return useContext(TopNavInsetContext)
}
